<template>
  <div class="mediation-statistics-container">
    <!-- 顶部筛选 -->
    <el-card class="filter-card">
      <div slot="header"><span>调解数据统计</span></div>
      <el-form :inline="true" size="small" label-width="80px">
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            style="width:360px"
          />
        </el-form-item>
        <el-form-item label="小区">
          <el-select v-model="filters.communityId" placeholder="请选择小区" clearable style="width:220px" @change="loadStatistics">
            <el-option v-for="c in communityList" :key="c.communityId" :label="c.name" :value="c.communityId" />
          </el-select>
        </el-form-item>
        <el-form-item label="调委会">
          <el-select v-model="filters.committeeId" placeholder="请选择调委会" clearable filterable style="width:220px" @change="loadStatistics">
            <el-option v-for="c in committeeList" :key="c.committeeId" :label="c.name" :value="c.committeeId" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadStatistics">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 总量指标卡片 -->
    <el-row :gutter="20" class="stat-cards">
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="stat-item">
            <div class="stat-label">调解总数</div>
            <div class="stat-value">{{ summary.total || 0 }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="stat-item">
            <div class="stat-label">处理中</div>
            <div class="stat-value stat-warning">{{ summary.processing || 0 }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="stat-item">
            <div class="stat-label">已完结</div>
            <div class="stat-value stat-success">{{ summary.finished || 0 }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="stat-item">
            <div class="stat-label">待受理</div>
            <div class="stat-value stat-info">{{ summary.pending || 0 }}</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 状态分布 -->
    <el-row :gutter="20" class="stat-cards">
      <el-col :span="6"><el-card shadow="hover"><div class="stat-item"><div class="stat-label">受理中</div><div class="stat-value">{{ summary.accepted || 0 }}</div></div></el-card></el-col>
      <el-col :span="6"><el-card shadow="hover"><div class="stat-item"><div class="stat-label">调解排期</div><div class="stat-value">{{ summary.scheduled || 0 }}</div></div></el-card></el-col>
      <el-col :span="6"><el-card shadow="hover"><div class="stat-item"><div class="stat-label">调解进行中</div><div class="stat-value">{{ summary.inProgress || 0 }}</div></div></el-card></el-col>
      <el-col :span="6"><el-card shadow="hover"><div class="stat-item"><div class="stat-label">达成协议</div><div class="stat-value stat-success">{{ summary.agreed || 0 }}</div></div></el-card></el-col>
    </el-row>
    <el-row :gutter="20" class="stat-cards">
      <el-col :span="6"><el-card shadow="hover"><div class="stat-item"><div class="stat-label">调解终止</div><div class="stat-value stat-danger">{{ summary.terminated || 0 }}</div></div></el-card></el-col>
      <el-col :span="6"><el-card shadow="hover"><div class="stat-item"><div class="stat-label">已归档</div><div class="stat-value">{{ summary.archived || 0 }}</div></div></el-card></el-col>
    </el-row>

    <!-- 图表区 -->
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card>
          <div slot="header"><span>新增/完结趋势</span></div>
          <div ref="trendChart" class="chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header"><span>纠纷类型分布</span></div>
          <div ref="typeChart" class="chart-box"></div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top:20px">
      <el-col :span="12">
        <el-card>
          <div slot="header"><span>调解员排行</span></div>
          <div ref="mediatorChart" class="chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header"><span>调解时效分布</span></div>
          <div ref="durationChart" class="chart-box"></div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top:20px">
      <el-col :span="12">
        <el-card>
          <div slot="header"><span>调委会维度</span></div>
          <el-table :data="committeeStats" border size="small">
            <el-table-column prop="committeeName" label="调委会" align="center" show-overflow-tooltip />
            <el-table-column prop="count" label="案件数" align="center" width="100" />
            <el-table-column label="完结数" align="center" width="100">
              <template slot-scope="scope">{{ scope.row.finishedCount || 0 }}</template>
            </el-table-column>
            <el-table-column label="完结率" align="center" width="120">
              <template slot-scope="scope">{{ _rate(scope.row.finishedCount, scope.row.count) }}%</template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header"><span>小区维度</span></div>
          <el-table :data="communityStats" border size="small">
            <el-table-column prop="communityId" label="小区ID" align="center" />
            <el-table-column prop="count" label="案件数" align="center" width="100" />
            <el-table-column label="完结数" align="center" width="100">
              <template slot-scope="scope">{{ scope.row.finishedCount || 0 }}</template>
            </el-table-column>
            <el-table-column label="完结率" align="center" width="120">
              <template slot-scope="scope">{{ _rate(scope.row.finishedCount, scope.row.count) }}%</template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { queryMediationStatistics, listCommittees } from '@/api/oa/mediationApi'
import { getCommunityId, getCommunity, getMyEnteredCommunitys } from '@/api/community/communityApi'

export default {
  name: 'MediationStatistics',
  data() {
    return {
      dateRange: [],
      filters: {
        communityId: '',
        committeeId: ''
      },
      communityList: [],
      committeeList: [],
      summary: {},
      stateStats: [],
      dayTrend: [],
      typeStats: [],
      committeeStats: [],
      communityStats: [],
      mediatorStats: [],
      duration: {},
      trendChart: null,
      typeChart: null,
      mediatorChart: null,
      durationChart: null
    }
  },
  mounted() {
    this.filters.communityId = getCommunityId()
    this._loadCommunities()
    this._loadCommittees()
    this.initCharts()
    window.addEventListener('resize', this.handleResize)
    this.loadStatistics()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    this.disposeCharts()
  },
  methods: {
    async _loadCommunities() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 100 })
        this.communityList = res.communitys || []
      } catch (e) {
        const cur = getCommunity()
        this.communityList = cur ? [cur] : []
      }
    },
    _loadCommittees() {
      listCommittees({}).then(res => {
        const d = res.data || res || {}
        this.committeeList = d.committees || []
      }).catch(() => {})
    },
    initCharts() {
      this.trendChart = echarts.init(this.$refs.trendChart)
      this.typeChart = echarts.init(this.$refs.typeChart)
      this.mediatorChart = echarts.init(this.$refs.mediatorChart)
      this.durationChart = echarts.init(this.$refs.durationChart)
    },
    disposeCharts() {
      if (this.trendChart) this.trendChart.dispose()
      if (this.typeChart) this.typeChart.dispose()
      if (this.mediatorChart) this.mediatorChart.dispose()
      if (this.durationChart) this.durationChart.dispose()
    },
    handleResize() {
      if (this.trendChart) this.trendChart.resize()
      if (this.typeChart) this.typeChart.resize()
      if (this.mediatorChart) this.mediatorChart.resize()
      if (this.durationChart) this.durationChart.resize()
    },
    _rate(finished, total) {
      const f = Number(finished || 0)
      const t = Number(total || 0)
      if (t === 0) return '0'
      return ((f / t) * 100).toFixed(1)
    },
    buildParams() {
      const params = {}
      if (this.filters.communityId) {
        params.communityId = this.filters.communityId
      }
      if (this.filters.committeeId) {
        params.committeeId = this.filters.committeeId
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0]
        params.endTime = this.dateRange[1]
      }
      return params
    },
    loadStatistics() {
      const params = this.buildParams()
      queryMediationStatistics(params).then(res => {
        const d = res.data || res || {}
        this.summary = d.summary || {}
        this.stateStats = d.stateStats || []
        this.dayTrend = d.dayTrend || []
        this.typeStats = d.typeStats || []
        this.committeeStats = d.committeeStats || []
        this.communityStats = d.communityStats || []
        this.mediatorStats = d.mediatorStats || []
        this.duration = d.duration || {}
        this.renderCharts()
      }).catch(err => {
        this.$message.error(err || '查询统计失败')
      })
    },
    resetFilter() {
      this.dateRange = []
      this.filters.communityId = getCommunityId()
      this.filters.committeeId = ''
      this.loadStatistics()
    },
    renderCharts() {
      this.renderTrendChart()
      this.renderTypeChart()
      this.renderMediatorChart()
      this.renderDurationChart()
    },
    renderTrendChart() {
      if (!this.trendChart) return
      const days = this.dayTrend.map(i => i.date || '')
      const counts = this.dayTrend.map(i => i.count || 0)
      const finished = this.dayTrend.map(i => i.finishedCount || 0)
      this.trendChart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['新增', '完结'] },
        grid: { left: 40, right: 20, top: 40, bottom: 30 },
        xAxis: { type: 'category', data: days, axisLabel: { rotate: 30 } },
        yAxis: { type: 'value', minInterval: 1 },
        series: [
          { name: '新增', type: 'line', smooth: true, data: counts, itemStyle: { color: '#409eff' }, areaStyle: { color: 'rgba(64,158,255,0.15)' } },
          { name: '完结', type: 'line', smooth: true, data: finished, itemStyle: { color: '#67c23a' }, areaStyle: { color: 'rgba(103,194,58,0.15)' } }
        ]
      })
    },
    renderTypeChart() {
      if (!this.typeChart) return
      const data = this.typeStats.map(i => ({ name: i.disputeType || '未知', value: i.count || 0 }))
      this.typeChart.setOption({
        tooltip: { trigger: 'item', formatter: '{a} <br/>{b}: {c} ({d}%)' },
        legend: { bottom: 0, type: 'scroll' },
        series: [{ name: '类型分布', type: 'pie', radius: ['40%', '65%'], data: data, itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 } }]
      })
    },
    renderMediatorChart() {
      if (!this.mediatorChart) return
      const top = this.mediatorStats.slice(0, 10)
      const names = top.map(i => i.mediatorName || i.mediatorId || '未知')
      const counts = top.map(i => i.count || 0)
      this.mediatorChart.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: 40, right: 20, top: 30, bottom: 50 },
        xAxis: { type: 'category', data: names, axisLabel: { rotate: 30 } },
        yAxis: { type: 'value', minInterval: 1 },
        series: [{ name: '处理数量', type: 'bar', data: counts, itemStyle: { color: '#67c23a' } }]
      })
    },
    renderDurationChart() {
      if (!this.durationChart) return
      const names = ['<7天', '7-15天', '15-30天', '>30天']
      const counts = [
        this.duration.lt7 || 0,
        this.duration.between7And15 || 0,
        this.duration.between15And30 || 0,
        this.duration.gt30 || 0
      ]
      this.durationChart.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: 40, right: 20, top: 30, bottom: 30 },
        xAxis: { type: 'category', data: names },
        yAxis: { type: 'value', minInterval: 1 },
        series: [{ name: '案件数', type: 'bar', data: counts, itemStyle: { color: '#e6a23c' } }]
      })
    }
  }
}
</script>

<style scoped>
.mediation-statistics-container {
  padding: 20px;
}
.filter-card {
  margin-bottom: 20px;
}
.stat-cards {
  margin-bottom: 20px;
}
.stat-item {
  text-align: center;
  padding: 10px 0;
}
.stat-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}
.stat-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
}
.stat-warning {
  color: #e6a23c;
}
.stat-success {
  color: #67c23a;
}
.stat-info {
  color: #909399;
}
.stat-danger {
  color: #f56c6c;
}
.chart-box {
  width: 100%;
  height: 320px;
}
</style>
